<template>
    <div class="position_center md-layout-item debtor_modal">
      <div class="modal-content">
        <form class="form-horizontal" action>
          <div class="md-layout">
            <div class="md-layout-item">
              <md-field :class="[{ 'md-error': errors.has('name')}]">
                <label>{{$t('ContactModal.firstname')}}</label>
                <md-input
                  v-model="form.name"
                  data-vv-name="name"
                  v-validate="modelValidations.name"
                  required
                  :disabled="readOnly"
                ></md-input>
                <span v-if="errors.has('name')" class="validation-error">{{ errors.first('name') }}</span>
              </md-field>

              <md-field :class="[{ 'md-error': errors.has('phone')}]">
                <label>{{$t('ContactModal.Contact.phone')}}</label>
                <md-input
                  v-model="form.phone"
                  data-vv-name="phone"
                  v-validate="modelValidations.phone"
                  required
                  :disabled="readOnly"
                ></md-input>
                <span v-if="errors.has('phone')" class="validation-error">{{ errors.first('phone') }}</span>
              </md-field>
              <md-field :class="[{ 'md-error': errors.has('email')}]">
                <label>{{ $t("ContactModal.Contact.email") }}</label>
                <md-input
                  v-model="form.email"
                  data-vv-name="email"
                  v-validate="modelValidations.email"
                  required
                  :disabled="readOnly"
                ></md-input>
                <span v-if="errors.has('email')" class="validation-error">{{ errors.first('email') }}</span>
              </md-field>
              <!-- <md-checkbox
                class="padding_vertical text_left"
                :disabled="readOnly"
                v-model="showAddress"
              >
                <div class="text_left">
                  <span>{{ this.$t("contact.Different.company") }}</span>
                </div>
              </md-checkbox> -->
              <template>
                <div v-if="showAddress">
                  <CountrySelect
                    v-on:input="onSelectCountry"
                    :labelText="$t('common.country')"
                    :value="form.country"
                    :companyType=enumDef.companyType.DebtorCompany
                    :required="true"
                    :disabled="readOnly"
                  ></CountrySelect>

                  <md-field :class="[{ 'md-error': errors.has('address_street')&&touched }]">
                    <label>{{ $t("Completion.Company.Street") }}</label>
                    <md-input
                      v-model="form.address_street"
                      data-vv-name="address_street"
                      v-validate="modelValidations.address_street"
                      required
                      :disabled="readOnly"
                    ></md-input>
                  </md-field>

                  <md-field :class="[{ 'md-error': errors.has('address_addon')&&touched }]">
                    <label>{{ $t("Completion.Company.AddressAddon") }}</label>
                    <md-input
                      v-model="form.address_addon"
                      data-vv-name="address_addon"
                      :disabled="readOnly"
                      v-validate="modelValidations.address_addon"
                    ></md-input>
                  </md-field>
                  <md-field :class="[{ 'md-error': errors.has('address_postcode')&&touched }]">
                    <label>{{ $t("common.postcode") }}</label>
                    <md-input
                      v-model="form.address_postcode"
                      data-vv-name="address_postcode"
                      :disabled="readOnly"
                      v-validate="modelValidations.address_postcode"
                      required
                    ></md-input>
                  </md-field>

                  <md-field :class="[{ 'md-error': errors.has('address_city')&&touched }]">
                    <label>{{ $t("common.city") }}</label>
                    <md-input
                      v-model="form.address_city"
                      data-vv-name="address_city"
                      :disabled="readOnly"
                      v-validate="modelValidations.address_city"
                      required
                    ></md-input>
                  </md-field>
                </div>
              </template>
            </div>
          </div>
        </form>
      </div>
      <div class="flex flex_between">
        <md-button class="md-blank" @click="reset">{{$t("DebtorSelect.reset")}}</md-button>
        <md-button
          @click="submit"
          class="opacity_5"
          :class="{ 'md-primary': isFormValid }"
        >{{$t("signUp.Continue")}}</md-button>
      </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import CountrySelect from "@/components/templates/select/CountrySelect.vue";
import {validateForm, validateRequiredFields} from "@/validation/validation";
import {enumDef} from "@/common/enumDefs";

export default {
  components: {
    CountrySelect
  },
  data() {
    return {
      touched: false,
      modelValidations: {
        name: {
          required: true
        },
        phone: {
          required: true
        },
        email: {
          required: true,
          email: true
        }
      },
      form: this.initForm(),
      showAdd: false,
      showAddress: false,
      readOnly: false,
      enumDef: enumDef,
    };
  },
  created() {},
  beforeMount() {
    let { contactData } = this;
    // if (contactData) {
    //   this.showAddress = contactData.hasDifferentAddress;
    // }
    let { data, readOnly } = this.noticeModalData;

    if (data.id) {
      this.readOnly = true;
    } else {
      this.readOnly = false;
    }
    this.changeContact(data);
  },
  methods: {
    initForm() {
      const defaultData = {
        address: {
          addressAddon: "",
          city: "",
          country: "",
          id: "",
          postCode: "",
          street: ""
        },
        address_addon: "",
        address_city: "",
        address_postcode: "",
        address_street: "",
        email: "",
        id: "",
        name: "",
        phone: "",
        country: ""
      };
      return defaultData;
    },
    reset() {
      this.readOnly = false;
      this.form=this.initForm();
      this.$store.dispatch("setActionContactData", null);
    },
    changeAddress(data) {
      // this.showAddress = data == "diff" ? true : false;
    },
    changeContact(data) {
      if (data.name) {
        this.form = { ...this.form, ...data };
        // this.showAddress = data.hasDifferentAddress;
        this.form.address_street = this.form.address.street;
        this.form.address_postcode = this.form.address.postCode;
        this.form.address_city = this.form.address.city;
        this.form.country = this.form.address.country;
        this.form.address_addon = this.form.address.addressAddon;
      } else {
        for (let key in this.form) {
          if (key == "address") {
            this.form[key] = {};
          } else {
            this.form[key] = "";
          }
        }
        this.form.name = "";
        this.form = { ...this.form };
      }
    },
    onSelectCountry(data) {
      this.form.country = data;
    },
    submit() {
      validateForm(this, this.$validator)
        .then(() => {
            if (this.showAddress) {
              this.form.address.street = this.form.address_street;
              this.form.address.postCode = this.form.address_postcode;
              this.form.address.city = this.form.address_city;
              this.form.address.addressAddon = this.form.address_addon;
              this.form.address.country = this.form.country;
            } else {
              this.form.address = this.debtorData.address;
            }
            this.form.address={}
            this.form.hasDifferentAddress = this.showAddress;
            this.noticeModalData.subFun(this.form);
            this.closeNoticeModal();
        })
        .catch(e => this.toast(e));
    },
    closeNoticeModal() {
      this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
    }
  },
  computed: {
    isFormValid() {
      return validateRequiredFields(this.form, this.modelValidations);
    },
    ...mapGetters({
      noticeModalData: "noticeModalData",
      contactData: "contactData",
      debtorData: "debtorData"
    })
  }
};
</script>
<style  lang="scss">
@import "@/assets/scss/seller.scss";
</style>
